export * from './SelectField';
export * from './components';
export * from './selectFieldClasses';

import React from 'react';
import {ReadOnlySelectField, type ReadOnlySelectFieldProps} from './components';
import {SelectField, type SelectFieldProps} from './SelectField';
export type {AutocompleteValue} from '@mui/material/useAutocomplete';

export type FieldRef = React.ForwardedRef<HTMLDivElement>;

type ExternalProps<
	T = any,
	Multiple extends boolean = false,
	DisableClearable extends boolean = false,
	FreeSolo extends boolean = false,
> =
	| SelectFieldProps<T, Multiple, DisableClearable, FreeSolo>
	| ReadOnlySelectFieldProps;

type InternalProps = {
	readOnly?: boolean;
};

const FieldInner = <
	T,
	Multiple extends boolean = false,
	DisableClearable extends boolean = false,
	FreeSolo extends boolean = false,
>(
	{
		readOnly,
		...props
	}: InternalProps & ExternalProps<T, Multiple, DisableClearable, FreeSolo>,
	ref: FieldRef,
) => {
	return !readOnly ? (
		<SelectField<T, Multiple, DisableClearable, FreeSolo>
			ref={ref}
			{...(props as SelectFieldProps<T, Multiple, DisableClearable, FreeSolo>)}
		/>
	) : (
		<ReadOnlySelectField ref={ref} {...(props as ReadOnlySelectFieldProps)} />
	);
};

export const FieldPrimitive = React.forwardRef(FieldInner) as <
	T,
	Multiple extends boolean = false,
	DisableClearable extends boolean = false,
	FreeSolo extends boolean = false,
>(
	props: InternalProps & ExternalProps<T, Multiple, DisableClearable, FreeSolo>,
) => JSX.Element;

export const Field = FieldPrimitive;

export default Field;
